import './Login.css'
import { useState, useEffect } from "react";
import { Button,CircularProgress } from '@mui/material';
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper';
import StandardTextfield from '../../components/StandardTextfield/StandardTextfield';
// IMGS
import loginLogo from '../../imgs/login_logo.svg';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from "notistack";
import axios from "axios";
// import { CapacitorRtspRtmpStream } from "capacitor-rtsp-rtmp-stream";


function Login() {
    const [loginCreds, setLoginCreds] = useState({ name: '', password: '', uid: '' })
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const [loading, setLoading] = useState(false)


    // const play = () => {
    //   alert('yyu')
    //   CapacitorRtspRtmpStream.streamRTSP("rtsp://0.tcp.in.ngrok.io:11632");
    // }
    
    const handleLogin  = async (e)  => {
        e.preventDefault();
        if (!loginCreds.name || !loginCreds.password) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })
        const email = loginCreds.name;
        const password = loginCreds.password;
        // console.log(loginCreds);
        try {
        setLoading(true);
        const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/admin/users/sign-in`,
                {
                    email,
                    password,
                }
            );
            if (res.data.success) {
                const userData = { ...res.data.data, auth: res.data.auth };
                console.log(userData);
                // dispatch({ type: ADD_USER, payload: userData });

                // Save the user ID and role to local storage
                localStorage.setItem("user_id", userData.user_id);
                localStorage.setItem("role", userData.role);
                localStorage.setItem("authToken", userData.auth);
                localStorage.setItem("name", userData.name);
                localStorage.setItem("email", userData.email);
                // Set the loggedIn key to true to indicate user is logged in
                localStorage.setItem("loggedIn", "true");

                // Role-based redirection
                if (userData.role === "admin") {
                    enqueueSnackbar("Admin Login Successful", {
                        variant: "success",
                    });
                    history.push('/dashboard');
                    window.location.reload(); 
                } else if(userData.role === "sub-admin"){
                    enqueueSnackbar("Sub Admin Login Successful", {
                        variant: "success",
                    });
                    history.push('/dashboard');
                    window.location.reload(); 
                } else{
                  enqueueSnackbar("Super Admin Can't Login Here!", {
                    variant: "error",
                });
                localStorage.clear();
                }
            } else {
                enqueueSnackbar(res.data.message, { variant: "error" });
            }
        } catch (error) {
            console.log(error);
            enqueueSnackbar(
                "Error occurred while signing in. Please try again.",
                { variant: "error" }
            );
        } finally {
            setLoading(false);
        }
        //   .then(async res => {
        //     if (res.data.success) {
        //       console.log(res.data);
        //       sessionStorage.setItem('ID_CardAdmin_user', JSON.stringify(res.data.result[0]))
        //       sessionStorage.setItem('ID_CardAdmin_user_auth', CryptoJS.AES.encrypt('true', process.env.REACT_APP_CRYPTO_JS_SECRET).toString())
        //       navigate(`/schools/${res.data.result[0].schoolid}`, { state: res.data.result[0] })
        //       setLoading(false);
        //       enqueueSnackbar('Login Successful !!!', { variant: 'success' });
        //     } else {
        //       enqueueSnackbar(res.data.result, { variant: 'error' });
        //       setLoading(false);
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err);
        //     setLoading(false);
        //     enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
        //   })
    }

    return (
      <IonicPageWrapper hideHeader>
        <div id="login">
          <img src={loginLogo} alt="Smart Light" className="login_logo" />

          <form className="login_form" onSubmit={handleLogin}>
            <StandardTextfield
              label="Name"
              variant="outlined"
              value={loginCreds.name}
              name="name"
              spreadValue={loginCreds}
              setValue={setLoginCreds}
            />

            <StandardTextfield
              label="Password"
              variant="outlined"
              type="password"
              value={loginCreds.password}
              name="password"
              spreadValue={loginCreds}
              setValue={setLoginCreds}
            />

            {/* <StandardTextfield label="Unique ID" variant="outlined" value={loginCreds.uid} name='uid'
                        spreadValue={loginCreds} setValue={setLoginCreds}
                    /> */}

            <Button
              disableElevation
              type='submit'
              // onClick={play}
              variant="contained"
              fullWidth
              disabled={loading}
            >
              {/* Login */}
              {!loading ? (
                "Login"
              ) : (
                <CircularProgress size={27} sx={{ color: "#fff" }} />
              )}
            </Button>
          </form>
        </div>
      </IonicPageWrapper>
    );
}

export default Login